import { Repeat, Eraser, ClipboardList } from "lucide-react";
import { Reveal, RevealGroup, RevealItem } from "@/components/landing/Reveal";

const SERVICES = [
  {
    icon: Repeat,
    title: "Ongoing Bookkeeping",
    body: "For business owners who want accurate, consistent bookkeeping without having to manage it themselves.",
    featured: false,
  },
  {
    icon: Eraser,
    title: "Bookkeeping Cleanup",
    body: "For businesses with records that are behind, incomplete, duplicated, or incorrectly categorized.",
    featured: true,
  },
  {
    icon: ClipboardList,
    title: "Books Diagnostic + Action Plan",
    body: "For situations where the extent of the bookkeeping problems cannot be determined during the initial consultation. The accounting records are reviewed, the issues are identified, and the business owner receives a written plan explaining what needs attention.",
    featured: false,
  },
];

export const Solutions = () => (
  <section
    id="solutions"
    data-testid="solutions-section"
    className="bg-warm-accent-soft py-24 md:py-32"
  >
    <div className="container-page">
      <Reveal>
        <p className="font-body text-xs sm:text-sm uppercase tracking-[0.25em] text-navy-700 mb-5">
          A right-sized approach
        </p>
        <h2 className="font-heading font-semibold text-4xl sm:text-5xl md:text-6xl leading-[1.05] tracking-tight text-navy-900 max-w-3xl">
          Let&rsquo;s Find the Right{" "}
          <span className="italic font-normal">Solution</span> for Your Business
        </h2>
        <p className="font-body text-base sm:text-lg leading-relaxed text-navy-900/70 max-w-2xl mt-6">
          Every business does not need the same service. We begin with a short
          consultation to understand the problem before recommending the
          appropriate next step.
        </p>
      </Reveal>

      <RevealGroup
        className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-14 items-stretch"
        stagger={0.12}
      >
        {SERVICES.map((s, i) => {
          const Icon = s.icon;
          return (
            <RevealItem key={i} className="h-full">
              <div
                data-testid={`service-card-${i}`}
                className={`group h-full flex flex-col rounded-lg p-9 border transition-transform duration-300 hover:-translate-y-1.5 ${
                  s.featured
                    ? "bg-navy-900 text-warm-neutral border-navy-900 md:-mt-4 md:mb-4 shadow-[0_30px_60px_-30px_rgba(15,20,40,0.55)]"
                    : "bg-white text-navy-900 border-navy-900/10"
                }`}
              >
                <span
                  className={`inline-flex h-12 w-12 items-center justify-center rounded-full ${
                    s.featured
                      ? "bg-warm-accent/20 text-warm-accent"
                      : "bg-warm-accent-soft text-navy-900"
                  }`}
                >
                  <Icon className="h-5 w-5" aria-hidden="true" />
                </span>
                <h3 className="font-heading text-2xl sm:text-3xl mt-6 leading-tight">
                  {s.title}
                </h3>
                <p
                  className={`font-body text-base leading-relaxed mt-4 ${
                    s.featured ? "text-warm-neutral/75" : "text-navy-900/70"
                  }`}
                >
                  {s.body}
                </p>
              </div>
            </RevealItem>
          );
        })}
      </RevealGroup>
    </div>
  </section>
);

export default Solutions;
